import { create } from "zustand";
import GetOfflineModeByCode from "../api-layer/offline-mode-api/GetOfflineModeByCode";
import PatchOfflineMode from "../api-layer/offline-mode-api/PatchOfflineMode";

export const useOfflineModeStore = create((set, get) => ({
  isOffline: null,
  loading: false,
  error: null,

  fetchOfflineMode: async () => {
    set({ loading: true, error: null });

    try {
      const response = await GetOfflineModeByCode("last");
      set({
        isOffline: response.data.isOffline,
        loading: false,
      });
    } catch (err) {
      set({
        error: "Failed to fetch offline mode",
        loading: false,
      });
    }
  },

  toggleOfflineMode: async () => {
    const current = get().isOffline;
    if (current === null) return;

    set({ loading: true, error: null });

    try {
      const formData = new FormData();
      formData.append("isOffline", !current);

      const response = await PatchOfflineMode("last", formData);

      set({
        isOffline: response.data.isOffline,
        loading: false,
      });
    } catch (err) {
      set({
        error: "Failed to toggle offline mode",
        loading: false,
      });
    }
  },

    setOfflineModeFromSocket: (payload) => {
        const isOffline = payload?.is_offline;
        if (typeof isOffline !== "boolean") return;

        set({
        isOffline,
        });
    },

}));